import * as _ from "lodash";
import { Dispatch } from "react-redux";
import { AuthActionCreators, IApplicationState } from "../";
import {
    IMatchRun, IMatchRunSwap, IMatchRunSettings, IMatchRunResults, IMatchRunChainStarter,
    IBaseResponse, IDonor, ICenterBase, IMatchRunRequest, ISwapFailureAnalysis, IMiracleMatch, IOneWay, ISingleEpletMmRisk, IMatchRunGroup, IMatchRunScenario, IMatchRunDiagnostics,
    IVoucherScenarioItem,
    IListItem
} from "@nkr/models/index";
import { IChainDisplay } from '@nkr/views/matching/models';

export interface IConfigureMatchRunResponse {
    data: {
        success: boolean,
        results: {
            settings: IMatchRunSettings,
            chainStarts: IDonor[],
            targets: IMiracleMatch[],
            centers: ICenterBase[],
            groups: IMatchRunGroup[],
            scenarios: IMatchRunScenario[],
            clusterStatusList: IListItem[]
        }
    }
}

export interface IMatchRunListResponse {
    data: {
        success: boolean,
        results: IMatchRun[]
    }
}

export interface IMatchRunResponse {
    data: {
        success: boolean,
        results: IMatchRun
    }
}

export interface IMatchRunFullResults {
    user: string,
    submittedDateTime: string,
    startedDateTime: string,
    completedDateTime: string,
    swaps: IMatchRunSwap[],
    results: IMatchRunResults,
    chains: IMatchRunChainStarter[],
    settings: IMatchRunSettings,
    diagnosticsData: IMatchRunDiagnostics,
    chainsToDisplay: IChainDisplay[],
    swapFailures: ISwapFailureAnalysis[],
    matchRunType: string,
    matchRunTypeId: number,
    oneWays: IOneWay[],
    epletMmRiskList: ISingleEpletMmRisk[],
    zeroDepthChainStartDonors: IDonor[],
    selectedCenters: ICenterBase[],
    rexmCount: number,
    // donorList: IDonor[]
}

export interface IMatchRunResultsResponse {
    data: {
        success: boolean,
        results: IMatchRunFullResults
    }
}

export interface IMatchRunScenariosResponse {
    data: {
        success: boolean,
        results: {
            groups: IMatchRunGroup[],
            scenarios: IMatchRunScenario[],
            voucherScenarioMap: IVoucherScenarioItem[]
        }
    }
}

export interface IRequestRexmResponse {
    data: {
        success: boolean,
        results: string
    }
}

export interface IRequestRexmBatchResponse {
    data: {
        success: boolean,
        results: {
            [oneWayId: number]: string
        }
    }
}

export interface ISubmitMatchRunResponse {
    data: {
        success: boolean,
        results: number
    }
}

export const ActionCreators = {
    // configureMatchRun: (targets: string, chainEndTargets: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IConfigureMatchRunResponse> => {
    //     let options = {
    //         url: `${__API__}/matching/configure-match-run?targets=${targets}&chainEndTargets=${chainEndTargets}`
    //     };

    //     return await dispatch(AuthActionCreators.apiGet(options));
    // },
    configureMatchRunNew: (targets: string, chainEndTargets: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IConfigureMatchRunResponse> => {
        let options = {
            url: `${__API__}/matching/configure-match-run-new?targets=${targets}&chainEndTargets=${chainEndTargets}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    // submitMatchRun: (request: IMatchRunRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<ISubmitMatchRunResponse> => {
    //     let options = {
    //         url: `${__API__}/matching/match-run/submit`,
    //         data: request
    //     };

    //     return await dispatch(AuthActionCreators.apiPost(options));
    // },
    submitMatchRunNew: (request: IMatchRunRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<ISubmitMatchRunResponse> => {
        let options = {
            url: `${__API__}/matching/match-run/submit-new`,
            data: request
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    getMatchRuns: (isNew: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IMatchRunListResponse> => {
        let options = {
            url: `${__API__}/matching/match-runs?isNew=${isNew ? 1 : 0}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getMatchRun: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMatchRunResponse> => {
        let options = {
            url: `${__API__}/matching/match-run/${id}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    // getResults: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMatchRunResultsResponse> => {
    //     let options = {
    //         url: `${__API__}/matching/results/${id}`
    //     };

    //     return await dispatch(AuthActionCreators.apiGet(options));
    // },
    getResultsNew: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMatchRunResultsResponse> => {
        let options = {
            url: `${__API__}/matching/results-new/${id}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    // getScenarios: () => async (dispatch: Dispatch<IApplicationState>): Promise<IMatchRunScenariosResponse> => {
    //     let options = {
    //         url: `${__API__}/matching/scenarios`
    //     };

    //     return await dispatch(AuthActionCreators.apiGet(options));
    // },
    getScenariosNew: () => async (dispatch: Dispatch<IApplicationState>): Promise<IMatchRunScenariosResponse> => {
        let options = {
            url: `${__API__}/matching/scenarios-new`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    requestExm: (matchRunId: number, key: number, donorId: number, recipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IRequestRexmResponse> => {
        var options = {
            url: `${__API__}/rexm/request?matchRunId=${matchRunId}&key=${key}&donorId=${donorId}&recipientid=${recipientId}`
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    requestExmBatch: (matchRunId: number, list: { key: number, donorId: number, recipientId: number }[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IRequestRexmBatchResponse> => {
        let options = {
            url: `${__API__}/rexm/request/batch?matchRunId=${matchRunId}`,
            data: list
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    makeMatchOffer: (donorList: { [key: number]: number }, recipientList: { [key: number]: number }, isChain: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/matching/make-match-offer`,
            data: {
                donorList,
                recipientList,
                isChain
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    deleteMatchRun: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/matching/match-run/${id}`
        };

        return await dispatch(AuthActionCreators.apiDelete(options));
    },
};
